import React from 'react';
// Images
import TestimonialSection from '../testimonials/TestimonialSection';

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid mb-20'>
      <TestimonialSection />
    </main>
  );
}

export default ContactPageMainContainer;
